import type { TourContent } from '../types/tour.types'
import { parseTourContent } from './tour-content-parser'

// Eager-load and parse every knowledge-base file once at module init. `.md` files
// are bundled as raw strings, so adding a `content/<key>.md` file registers it
// automatically (keyed by its front-matter `key` or filename).
const rawFiles = import.meta.glob<string>('../content/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
})

const CONTENT_BY_KEY: Record<string, TourContent> = {}
for (const [path, raw] of Object.entries(rawFiles)) {
  const fileKey = path.split('/').pop()!.replace(/\.md$/, '')
  const parsed = parseTourContent(raw, fileKey)
  CONTENT_BY_KEY[parsed.key] = parsed
}

export function useTourContent() {
  function getContent(key: string | null | undefined): TourContent | null {
    if (!key) return null
    return CONTENT_BY_KEY[key] ?? null
  }
  function hasContent(key: string | null | undefined): boolean {
    return !!key && key in CONTENT_BY_KEY
  }
  return { getContent, hasContent }
}
